import { forwardRef } from "react"

const { useSwiper } =  require("swiper/react") 

/* Protopia Ecosystem component */
export interface INextButtonProps {
    onClick: () => void
}
const Next = forwardRef((props: INextButtonProps, ref:any): JSX.Element => {
    const swiper = useSwiper()
    const onClick = () => { 
        swiper.slideNext()
        props.onClick()
    }
    return <div className='position-absolute unvisibled' onClick={onClick} ref={ref} />
})
export default Next 